import axios from "axios";
const APIBASE = process.env.REACT_APP_API;

const queue = (token) => {
    const headers = {
        headers: { "x-access-token": token },
    };
    const proxyUrl = (customerId) => `${APIBASE}/customers/${customerId}/proxy`;

    const clearQueue = async (customerId, userId) => {
        const payload = { user_id: userId }
        const response = await axios.post(`${proxyUrl(customerId)}/queue/clear`,payload, headers);
        if(response.data){
            return response.data;
        }
        return {};
    }

    const listQueue = async (customerId, userId) => {
        const response = await axios.get(`${proxyUrl(customerId)}/queue/${userId}`, headers);
        if(!response.data) return;
        const listQueue = response.data;
        const listIds = response.data.map((queue) => queue.client_id);
        return { listIds, listQueue}
    } 

    const customerInQueue = async (customerId, listIds) => {
        const payload = { list: listIds }
        const response = await axios.post(`${proxyUrl(customerId)}/customer/customers_in_queue`, payload, headers);
        if(!response.data) return;
        return response.data.res;
    }
    
    const deleteMsgQueue = async (customerId, id) => {
        const response = await axios.delete(`${proxyUrl(customerId)}/queue/${id}`, headers);
        if(!response.data) return;
        return response.data;
    } 

    const getCountMsgQueue = async (customerId, userId) => {
        const response = await axios.get(`${proxyUrl(customerId)}/queue/count/${userId}`, headers);
        if(!response.data) return;
        return response.data;
    }
    return { clearQueue, listQueue, customerInQueue, deleteMsgQueue, getCountMsgQueue }
}

export default queue;
